const eventName = "do-chat:thread-documents-changed";

export function publishThreadDocumentsChanged(threadId) {
  if (!threadId || typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(eventName, { detail: { threadId: String(threadId) } }),
  );
}

export function onThreadDocumentsChanged(handler) {
  if (typeof window === "undefined") return () => {};
  const listener = (event) => handler(event.detail?.threadId);
  window.addEventListener(eventName, listener);
  return () => window.removeEventListener(eventName, listener);
}
